"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _popupConfig = require("@/api/popup/popupConfig.js");
var _vuedraggable = _interopRequireDefault(require("vuedraggable"));
var _index = _interopRequireDefault(require("../../uploadImg/index.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 导入API函数
//拖拽组件
var _default = exports.default = {
  name: 'graphicnavigationstyle',
  props: {
    datas: Object,
    title: String
  },
  data: function data() {
    return {
      resPath: process.env.VUE_APP_IMAGE_PATH || '',
      dragOptions: {
        //拖拽配置
        animation: 200
      },
      predefineColors: [
      // 颜色选择器预设
      '#ff4500', '#ff8c00', '#ffd700', '#90ee90', '#00ced1', '#1e90ff', '#c71585', '#409EFF', '#909399', '#C0C4CC', 'rgba(255, 69, 0, 0.68)', 'rgb(255, 120, 0)', 'hsv(51, 100, 98)', 'hsva(120, 40, 94, 0.5)', 'hsl(181, 100%, 37%)', 'hsla(209, 100%, 56%, 0.73)', '#c7158577'],
      optionsType: [{
        type: '10',
        name: '内部链接'
      }, {
        type: '11',
        name: '外部链接'
      }],
      // 选择跳转类型
      emptyText: '',
      uploadImgDataType: null,
      pageList: [],
      // 页面列表
      loadingPageList: false // 加载页面列表状态
    };
  },
  created: function created() {
    // 检查是否存在内部链接类型的项目，如果存在则获取页面列表
    var hasInternalLink = this.datas.imageList && this.datas.imageList.some(function (item) {
      return item.linktype === '10';
    });
    if (hasInternalLink) {
      this.getPageList();
    }
  },
  methods: {
    // 获取页面列表
    getPageList: function () {
      var _getPageList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(this.pageList.length > 0)) {
                _context.next = 1;
                break;
              }
              return _context.abrupt("return");
            case 1:
              _context.prev = 1;
              this.loadingPageList = true;
              _context.next = 2;
              return (0, _popupConfig.queryPageList)();
            case 2:
              response = _context.sent;
              if (response.code === 200 && response.data) {
                // 将返回的页面数据转换为下拉选项格式
                this.pageList = response.data.map(function (item) {
                  return {
                    value: item.pageUrl,
                    label: item.pageName
                  };
                });
              } else {
                console.error('获取页面列表失败:', response);
                this.$message.error('获取页面列表失败');
              }
              _context.next = 4;
              break;
            case 3:
              _context.prev = 3;
              _t = _context["catch"](1);
              console.error('获取页面列表错误:', _t);
              this.$message.error('获取页面列表失败');
            case 4:
              _context.prev = 4;
              this.loadingPageList = false;
              return _context.finish(4);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1, 3, 4, 5]]);
      }));
      function getPageList() {
        return _getPageList.apply(this, arguments);
      }
      return getPageList;
    }(),
    // 处理链接类型变化
    handleLinkTypeChange: function handleLinkTypeChange(item) {
      item.internalLink = '';
      // 当切换到内部链接时，确保有页面列表数据
      if (item.linktype === '10' && this.pageList.length === 0) {
        this.getPageList();
      }
    },
    showUpload: function showUpload(type) {
      this.uploadImgDataType = type;
      this.$refs.upload.showUpload();
    },
    // 单个"添加导航"：根据当前导航类型决定行为
    // - 图片模式(2)：直接打开上传
    // - 文字(1)/混合(0)：push 空项，混合模式下图片在卡片内点击上传
    addNavItem: function addNavItem() {
      if (this.datas.navigationType === 2) {
        this.showUpload('0');
      } else {
        this.datas.imageList.push({
          src: '',
          text: '',
          linktype: '10',
          internalLink: ''
        });
      }
    },
    // 提交
    uploadInformation: function uploadInformation(res) {
      var t = this.uploadImgDataType;
      if (t === '0') {
        // 图片导航模式 - 追加新项
        this.datas.imageList.push({
          src: res,
          text: '',
          linktype: '10',
          internalLink: ''
        });
      } else if (t === '1') {
        // 背景图
        this.datas.bgImg = res;
      } else if (typeof t === 'string' && t.indexOf('item-') === 0) {
        // 替换某一项的图片
        var idx = parseInt(t.slice(5), 10);
        if (!isNaN(idx) && this.datas.imageList[idx]) {
          this.$set(this.datas.imageList[idx], 'src', res);
        }
      }
    },
    // 清空背景图片
    clear: function clear() {
      this.datas.bgImg = '';
    },
    /* 删除图片列表的图片 */deleteimg: function deleteimg(index) {
      this.datas.imageList.splice(index, 1);
    }
  },
  components: {
    vuedraggable: _vuedraggable.default,
    uploadImg: _index.default
  }
};